<!--
   Created by qing on 2020/12/23
   Des: 
-->
<template>
  <van-popup
    class="mix-form-dash-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <div class="mix-form-dash-popup-container" v-if="visibleInfo.visible">
      <iframe
        :src="dashSrc"
        width="100%"
        height="100%"
        frameborder="0">
      </iframe>
    </div>
  </van-popup>
</template>

<script>
  export default {
    props: {
      stackList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {

        visibleInfo: {
          visible: false
        },
        dashSrc: ''
      }
    },
    created() {
    },
    methods: {
      open({appId, dashboardId}) {
        this.dashSrc = ''
        this.$store.dispatch('actionNodeSave', {
          companyId: this.$store.getters.currentCompanyId,
          userId: this.$store.getters.userId,
          appId: appId,
          dashboardId: dashboardId,
          hiddenList: [],
          token: this.$store.state.token,
          env: this.$store.getters.env
        }).then(res => {
          if (process.env.NODE_ENV === 'production') {
            this.dashSrc = `${location.origin}${this.$DS_BASE_PATH}/#/dashboard?key=${res.nodeKey}`
          } else {
            this.dashSrc = `https://node.dev.161.54188.online${this.$DS_BASE_PATH}/#/dashboard?key=${res.nodeKey}`
          }
        }).catch(console.error)

        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
      },
      beforeClose() {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="less">

  .mix-form-dash-popup {

    .mix-form-dash-popup-container {
      width: 100%;
      height: 100%;
    }
  }
</style>